import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import Reveal, { EASE } from "@/components/Reveal";
import { PRIZES, TELEGRAM_URL } from "@/data/site";

const grand = PRIZES[0];
const featured = PRIZES.slice(1, 4);

export default function Showcase() {
  return (
    <section id="showcase" className="relative overflow-hidden py-20 sm:py-28">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[400px] w-[700px] -translate-x-1/2 spotlight-gold blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal className="max-w-2xl">
          <p className="font-mono text-[11px] font-bold uppercase tracking-[0.3em] text-[#00F2B6] sm:text-sm">
            Pilihan Hadiah
          </p>
          <h2 className="mt-3 font-display text-3xl font-black uppercase tracking-tight text-white sm:text-5xl">
            Panggung Utama{" "}
            <span className="text-gradient-gold"> untuk Hadiah Terbaik</span>
          </h2>
        </Reveal>

        <div className="mt-12 grid items-stretch gap-6 lg:grid-cols-5 sm:mt-16">
          <motion.article
            data-testid="showcase-card-mercedes"
            initial={{ opacity: 0, scale: 0.96, clipPath: "inset(8% 8% 8% 8% round 24px)" }}
            whileInView={{
              opacity: 1,
              scale: 1,
              clipPath: "inset(0% 0% 0% 0% round 24px)",
            }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 1.1, ease: EASE }}
            className="group relative overflow-hidden rounded-3xl border border-white/10 lg:col-span-3"
          >
            <img
              src={grand.image}
              alt={grand.name}
              loading="lazy"
              className="h-full min-h-[320px] w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#07090E] via-[#07090E]/20 to-transparent" />
            <span className="glass absolute left-5 top-5 rounded-full px-4 py-1.5 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-[#F0B429] sm:text-xs">
              {grand.tag}
            </span>
            <div className="absolute inset-x-5 bottom-5 flex flex-wrap items-end justify-between gap-4 sm:inset-x-8 sm:bottom-8">
              <div>
                <p className="font-mono text-xs font-bold tracking-[0.25em] text-[#00F2B6]">
                  {grand.lotsLabel} Lot
                </p>
                <h3 className="mt-1.5 font-display text-3xl font-black uppercase text-white sm:text-5xl">
                  {grand.name}
                </h3>
              </div>
              <Button
                asChild
                data-testid="showcase-ask-mercedes-button"
                className="h-11 rounded-full bg-[#F0B429] font-bold text-[#07090E] hover:bg-[#D9A019] glow-gold"
              >
                <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" onClick={() => window.fbq && window.fbq("trackCustom", "TelegramClick")}>
                  Tanya Hadiah Ini
                  <ArrowUpRight className="h-4 w-4" />
                </a>
              </Button>
            </div>
          </motion.article>

          <div className="grid gap-6 lg:col-span-2">
            {featured.map((p, i) => (
              <Reveal
                key={p.id}
                delay={0.12 + i * 0.12}
                className="h-full"
                testId={`showcase-card-${p.id}`}
              >
                <article className="group relative h-full min-h-[180px] overflow-hidden rounded-3xl border border-white/10">
                  <img
                    src={p.image}
                    alt={p.name}
                    loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#07090E] via-[#07090E]/25 to-transparent" />
                  <div className="absolute inset-x-5 bottom-5">
                    <p className="font-mono text-[11px] font-bold tracking-[0.25em] text-[#00F2B6]">
                      {p.lotsLabel} Lot
                    </p>
                    <h3 className="mt-1 text-lg font-bold text-white sm:text-xl">
                      {p.name}
                    </h3>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
